/* eslint-disable */
import React, { useState, useCallback } from "react";
import Container from "../UI/Container";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SquareFootIcon from "@mui/icons-material/SquareFoot";
import MendetoryIcon from "../UI/mendetoryicon";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useReactToPrint } from "react-to-print";
import ShippingPdf from "./ShippingHistoryPdf";
import {maxColumnWidth } from "../../util";

import * as XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
var pixelWidth = require('string-pixel-width');
import {
  Box,
  Button,
  Stack,
  Autocomplete,
  TextField,
  Menu,
  MenuItem,
  Grid
} from "@mui/material";
import { DataGridPro, useGridApiRef } from "@mui/x-data-grid-pro";
import axios from "../../api";
import MaterialPropertiesModal from "../UI/MaterialProperties";
import { useMaterialPropertiesContext } from "../../Context/MaterialPropertiesContext";
import SwitchPro from "../UI/switchPro";
import { usePopUpContext } from "../../Context/PopupMessage";
import { formattedDate } from "../../util";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { useGlobalDataContext } from "../../Context/AppGlobalData";
function BrowseContainer(props) {
  const usertype =localStorage.getItem("type")
  let detaildata =JSON.parse(localStorage.getItem("detail"))
  React.useEffect(() => {
   if(usertype && usertype==="E"){
  
   
    setMillValue({keyStr:detaildata.cusNo,dispStr:detaildata.cusNm})
   }
   if(detaildata?.dsblBrh===1){
    setInventoryAtValue({keyStr:detaildata.brh,dispStr:detaildata.brhNm})
   }
  
   
  }, []);
  const { inventoryAtValue, setInventoryAtValue,  millValue, setMillValue } = useGlobalDataContext();
  const { setPopupMessage, setLoading } = usePopUpContext();
  const [pdfFilter, setPdfFilter] = useState([]) 
  const [selectedFilter, setSelectedFilter] = useState([])
  const [assetColumns, setColumns] = useState([
    {
      field: "partNo",
      headerName: "Part No",
      sortable: false,
      width: 200,
    },
    {
      field: "cusPoNo",
      headerName: "Mill Order No",
      sortable: false,
      width: 250,
    },
    {
      field: "eusrPoNo",
      headerName: "End-User PO",
      sortable: false,
      width: 120,
    },
    {
      field: "cusTagNo",
      headerName: "Mill Coil ID",
      sortable: false,
      width: 250,
    },
    {
      field: "procrCoilStf",
      headerName: "Processor Coil ID",
      renderCell: (params) => (
        <div
          dangerouslySetInnerHTML={{
            __html: params.value,
          }}
        />
      ),
      sortable: false,
      width: 180,
    },
    {
      field: "wgtStr",
      headerName: "LBS",
      sortable: false,
      width: 100,
      type: 'number',
    },
    {
      field: "pcsStr",
      headerName: "Pieces",
      sortable: false,
      width: 100,
      type: 'number',
    },
    {
      field: "gaStr",
      headerName: "Gauge",
      sortable: false,
      width: 100,
    },
    {
      field: "wdthStr",
      headerName: "Width",
      sortable: false,
      width: 100,
      type: 'number',
    },
    {
      field: "lgthStr",
      headerName: "Length",
      sortable: false,
      width: 100,
      type: 'number',
    },
    {
      field: "blNoStf",
      headerName: "B/L",
      renderCell: (params) => (
        <div
          dangerouslySetInnerHTML={{
            __html: params.value,
          }}
        />
      ),
      sortable: false,
      width: 100,
    },
    {
      field: "shpDts",
      headerName: "Ship Date",
      sortable: false,
      width: 100,
    },
  ]);
  const handleGo = async (e, nextCall) => {
    e.preventDefault();

    setLoading(true)

    var postData = {
      prsMd: "P",
      cusNo:millValue?.keyStr===""?null: Number(millValue?.keyStr),
    };
    var filter = {
      "Mill": millValue?.dispStr,
    }


    if (checked) {
      postData["useMetUnt"] = 1;
    } else {
      postData["useMetUnt"] = 0;
    }
    if (inventoryAtValue?.keyStr !=="") {
      postData["brh"] = inventoryAtValue?.keyStr;
      filter["Shipped From"] = inventoryAtValue?.dispStr;
      
    }


    if (millOrderNoValue) {
      postData["cusPoNo"] = `${millOrderNoValue}`;
      filter["Mill Order No"] = millOrderNoValue;
    }

    if (millCoilIDValue) {
      postData["cusTagNo"] = `${millCoilIDValue}`;
      filter["Mill Coil ID"] = millCoilIDValue;
    }

    if (partNoValue) {
      postData["partNo"] = partNoValue.keyStr;
      filter["Part No"] = partNoValue.dispStr;
    } else if (partNoInputValue && partNoInputValue.trim() !== "") {
      postData["partNo"] = partNoInputValue.trim();
      filter["Part No"] = partNoInputValue.trim();
    }

    if (endUserValue) {
      postData["eusrNo"] = Number(endUserValue.keyStr);
      filter["End-User"] = endUserValue.keyStr
    }

    if (endUserPOValue) {
      postData["eusrPoNo"] = `${endUserPOValue}`;
      filter["End-User PO"] = endUserPOValue
    }

    if (fromDate) {
      postData["fmDt"] = formattedDate(fromDate, "YYYYMMDD");
      filter["From Date"] = formattedDate(fromDate, "YYYYMMDD");
    }

    if (toDate) {
      postData["toDt"] = formattedDate(toDate, "YYYYMMDD");
      filter["To Date"] = formattedDate(toDate, "YYYYMMDD");
    }

    if (widthFromValue) {
      postData["fmWdth"] = Number(widthFromValue);
      filter["From Width"] = widthFromValue;
    }

    if (widthToValue) {
      postData["toWdth"] = Number(widthToValue);
      filter["To Width"] = widthToValue;
    }

    if (lengthFromValue) {
      postData["fmLgth"] = Number(lengthFromValue);
      filter["From Length"] = lengthFromValue;
    }

    if (lengthToValue) {
      postData["toLgth"] = Number(lengthToValue);
      filter["To Length"] = lengthToValue;
    }

    if (gaugeFromValue) {
      postData["fmGa"] = Number(gaugeFromValue);
      filter["From Gauge"] = gaugeFromValue;
    }

    if (gaugeToValue) {
      postData["toGa"] = Number(gaugeToValue);
      filter["To Gauge"] = gaugeToValue;
    }
    setSelectedFilter(postData)
    setPdfFilter(filter)
    const data = await getAll(postData)
   
    if(data.success){
      setLoading(false)
      setRows(data.rowsData);
    
      const updatedData = assetColumns.map(x => (
        
        x.field === "wgtStr"?{ ...x,headerName:data.wgtUm, width: maxColumnWidth(x.field, data.rowsData) }:  
        x.field ==="procrCoilStf"||x.field ==="blNoStf" ? x: { ...x,  width: maxColumnWidth(x.field,data.rowsData) } ));
     setColumns(updatedData)
    }
  };

  const apiRef = useGridApiRef();
  const [rows, setRows] = useState([]);
  const { setTagCtlNoValue, setPrsMdValue } = useMaterialPropertiesContext();

  const [openShippedFrom, setOpenShippedFrom] = useState(false);
  const [shippedFromOption, setShippedFromOption] = useState([]);

  const [openMill, setOpenMill] = useState(false);
  const [millOption, setMillOption] = useState([]);

  const [millOrderNoValue, setMillOrderNoValue] = useState(null);

  const [millCoilIDValue, setMillCoilIDValue] = useState(null);

  const [openEndUser, setOpenEndUser] = useState(false);
  const [endUserOption, setEndUserOption] = useState([]);
  const [endUserValue, setEndUserValue] = useState(null);

  const [endUserPOValue, setEndUserPOValue] = useState(null);

  const [openPartNo, setOpenPartNo] = useState(false);
  const [partNoOption, setPartNoOption] = useState([]);
  const [partNoValue, setPartNoValue] = useState(null);
  const [partNoInputValue, setPartNoInputValue] = useState("");

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const [widthFromValue, setWidthFromValue] = useState(null);
  const [widthToValue, setWidthToValue] = useState(null);
  const [lengthFromValue, setLengthFromValue] = useState(null);
  const [lengthToValue, setLengthToValue] = useState(null);
  const [gaugeFromValue, setGaugeFromValue] = useState(null);
  const [gaugeToValue, setGaugeToValue] = useState(null);
  const [dimensionFilterVisibility, setDimensionFilterVisibility] = useState(false);
  const [openMaterialPropertiesModal, setOpenMaterialPropertiesModal] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [checked, setChecked] = useState(false);



  const handleCellClick = (params) => {
    if (params.field === "procrCoilStf") {

      if (params.row.isTot === 0) {

        
        setOpenMaterialPropertiesModal(true);
        setTagCtlNoValue(params.row.tagCtlNo);

        setPrsMdValue({  
          useMetUnt: checked?1:0,
          prsMd: "S",
          tollBlNo: params.row.tollBlNo,
          tagCtlNo: params.row.tagCtlNo});
      }
     
    }
    if (params.field === "blNoStf") {

      if (params.row.clckEnbl === 1) {
        getFileName(params.row)
     
      }
     
    }
  };

  const handleMore = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const getValue = (params, setValue, setOpen) => {
   
    setLoading(true)
    setValue([])
    let url = "/lookupsvc";
    let headers = {
      "invera-service-name": "scbesv",
    };
    console.log(params);
    axios
      .post(url, params, headers)
      .then((res) => {
      
        var arrResponse = res.data.output.fldTbl;
        setValue(arrResponse);
        setLoading(false)
        setOpen(true);
        if(res.data.output.rtnSts===2){
          setPopupMessage({ state: true, type: "warning", message:res.data.output?.msg })
        }
      
      })
      .catch((e) => {
        console.log(e);
        setLoading(false)
        setPopupMessage({ state: true, type: "error", message: e.response.data?.Message })
      });
  };

 
  const getAll = async (postData)=>{
    setLoading(true)
    let success =true
    let flag =true;
    let nextTotal = null
    let nextRecord = null
     let frstTmFlg =1
     let rowsData = []
     let nTotWgt
     let nRowID
     let wgtUm ="LBS"
    while (flag) {
     
      if(nextRecord){
        postData["sTagCtlNo"] = nextRecord;
        postData["sTotPcs"] = nextTotal
        postData["sTotWgt"] = nTotWgt
        postData["sRowId"] = nRowID
      }
        
        postData["frstTmFlg"] = frstTmFlg
   
   await axios
        .post("/shiphistbrowse", postData /*axiosConfig*/)
        .then((res) => {
        
             frstTmFlg=0
             rowsData = [...rowsData, ...res.data.output.fldTbl]
          if (res.data.output.eof === 0) {
            flag = true
            nextRecord = res.data.output.nTagCtlNo;
            nextTotal = res.data.output.nTotPcs;
            nTotWgt= res.data.output.nTotWgt
            nRowID = res.data.output.nRowId
          } else{
            flag = false
          }

          if(res.data.output.rtnSts===2){
            setPopupMessage({ state: true, type: "warning", message:res.data.output?.msg })
          }
          wgtUm = res.data.output.wgtUm
        })
        .catch((err) => {
          setLoading(false)
          success=false
          flag = false
          setPopupMessage({ state: true, type: "error", message: err.response.data?.Message })
         let data = {success:false,rowsData:rowsData ,wgtUm:wgtUm}
          return data
          // setRows([]);
        });
    }
    setLoading(false)
    let data = {success:true,rowsData:rowsData ,wgtUm:wgtUm}
    return data

  }
  const hideMaterialPropertiesModal = () => {
    setOpenMaterialPropertiesModal(false);
  };

  const toggleMetricUnits = useCallback(() => {
    setChecked((checked) => !checked);
  }, []);

  const dimensionFilterToggler = useCallback(() => {
    setDimensionFilterVisibility(
      (dimensionFilterVisibility) => !dimensionFilterVisibility
    );
  }, []);
  const [typingTimer, setTypingTimer] = useState();
  const SearchServiceCall = (async (newValue, parms, setOption, setOpen) => {
    clearTimeout(typingTimer);
    if (newValue) {
      setOption([])
      const typingTimer_ = setTimeout(async () => {
        setLoading(true)
        getValue(parms, setOption, setOpen);
      }, 1000);
      setTypingTimer(typingTimer_);
    }
  });
  const [openPdf, setOpenPdf] = useState(null)
  const [wgtUm, setwgtUm] = useState("LBS")
  const handleAfterPrint = React.useCallback(() => {
    setOpenPdf(null)
    handleClose()
  }, []);


  const handleOnBeforeGetContent = React.useCallback(async () => {

    var postData = {
      ...selectedFilter,
      prsMd: "E",  // "E",
    };

    const data = await getAll(postData)
    console.log("success", data)
    if (data.success) {
      setLoading(false)
      setwgtUm(data.wgtUm)
      setOpenPdf(data.rowsData);

    }


    return new Promise((resolve) => {
      // setText("heasdfaj");
      resolve();


    });
  }, [[]]);

  const componentRef = React.useRef();
  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);
  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: `ShippingHistory_${new Date().toJSON().slice(0, 10)}`,
    onBeforeGetContent: handleOnBeforeGetContent,
    removeAfterPrint: true,
    onAfterPrint: handleAfterPrint
  });

  const addStyleToSheet = (workbookBlob, apiData) => {
    try {
      console.log("addStyleToSheet-----------------------")
        return XlsxPopulate.fromDataAsync(workbookBlob).then((workbook) => {
            workbook.sheets().forEach((sheet) => {
                // Get the used range of the sheet
                const usedRange = sheet.usedRange();
  
                // Set the first row background color to green up to the last column with data
                const lastColumnNumber = usedRange._maxColumnNumber;
                let lastColumnLetter;
                if (lastColumnNumber <= 26) {
                    lastColumnLetter = String.fromCharCode(64 + lastColumnNumber);
                } else {
                    const firstLetter = String.fromCharCode(64 + Math.floor((lastColumnNumber - 1) / 26));
                    const secondLetter = String.fromCharCode(64 + ((lastColumnNumber - 1) % 26) + 1);
                    lastColumnLetter = `${firstLetter}${secondLetter}`;
                }
                // sheet.range(`A1:${lastColumnLetter}1`).style({
                //     fill: {
                //         type: "solid",
                //         color: "#90EE90"
                //     },
                //     // fgColor: { argb: 'FF90EE90' }, // Green color
                //     // color: "#ffffff",
                // });
  
                // Set the width of each column based on its maximum width
                for (let colNumber = 1; colNumber <= lastColumnNumber; colNumber++) {
                    const columnLetter = String.fromCharCode(64 + colNumber);
                    const column = sheet.column(columnLetter);
  
                    // Get the maximum width of the column
                    let maxWidth = 0;
                    const rowCount = usedRange._numRows;
                    for (let row = 1; row <= rowCount; row++) {
                        const cell = column.cell(row);
                        const cellValue = cell._value !== undefined ? cell._value.toString() : ''; // Convert value to string
                        // const cellWidth = cellValue.length;
                        maxWidth = Math.max(maxWidth, pixelWidth(cellValue, { size: 2 }));
                    //    cell.value(cellValue); // Set the cell value as a string
                    }
  
                    // Set the width of the column
                    // column.autoSize();
                    // column.width(250); // Adjust the width as needed
                    column.width((maxWidth + 3) <= 100 ? maxWidth + 3 : 100); // Adjust the width as needed                     
                    column.style({ wrapText: true });
                    // Alternatively, you can set a specific width for all columns
                    // column.width(10); // Set a specific width for all columns
                }
  
            });
  
            return workbook.outputAsync().then((workbookBlob) => URL.createObjectURL(workbookBlob));
        }).catch((error) => {
            console.error("Error in addStyleToSheet", error);
            return XlsxPopulate.fromDataAsync(workbookBlob).then((workbook) => {
                return workbook.outputAsync().then((workbookBlob) => URL.createObjectURL(workbookBlob));
            })
        });
    }
    catch (err) {
        console.error("Error in addStyleToSheet", err);
        return XlsxPopulate.fromDataAsync(workbookBlob).then((workbook) => {
            return workbook.outputAsync().then((workbookBlob) => URL.createObjectURL(workbookBlob));
        })
    }
  };
  const exportOnClick = async (filename) => {

        let type ="bill_"
        let url = `/downloadfile?filepath=${filename}&&filename=${type}`

        axios({
            method: 'get',
            url: url,
            responseType: 'blob'

        })
            .then((res, req) => {
              
                 
                    const url = window.URL.createObjectURL(new Blob([res.data])); 
                    var fileName ="bill_"+ Date.now() + ".txt"
                    const link = document.createElement('a');
                    link.href = url;
                    // link.target="_blank" 
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
          

            })
            .catch((error) => {
                setPopupMessage({ state: true, type: "error", message: error.response.data.message })
            })

}
const getFileName = async( row) => {
 
  setLoading(true)
 
  let url = "/arcdocsvc";
  let params ={
  "prsMd":"R",
  "busDocTyp": "BL",
  "cusNo":millValue?.keyStr===""?null: Number(millValue?.keyStr),
    "fldTbl":[
          {
              "brh": inventoryAtValue?.keyStr, 
              "refPfx":"TB", 
              "refNo": row.tollBlNo,
             
              "refDt":row.shpDt
          }
      ]
  }
  
   await axios
    .post(url, params)
    .then((res) => {
      var arrResponse = res.data.output.prtFileNm;
      
      exportOnClick(arrResponse)
      setLoading(false)
      // console.log("arrResponse");
      console.log(arrResponse);
    })
    .catch((e) => {
      console.log(e);
      setLoading(false)
      setPopupMessage({ state: true, type: "error", message: e.response.data?.Message })
    });
};
const exportToXls = async () => {
  let fileName =`ShippingHistory_${Date.now()}`
  var postData = {
    ...selectedFilter,
    prsMd: "E",  // "E",
    


  };
  
  const apiData = await getAll(postData)

  if (apiData.success) {
    
    let keyMap = {
      partNo: "Part No",
      cusPoNo: "Mill Order No",
      eusrPoNo: "End-User PO",
      cusTagNo: "Mill Coil ID",
      procrCoilStf: "Processor Coil ID",
      wgt: apiData.wgtUm,
      pcs: "Pieces",
      gaStr: "Gauge",
      wdthStr:"Width" ,
      lgthStr: "Length",
      tollBlNo: "B/L",
      shpDts: "Ship Date",
    
    };
   
let pdfFilterString =  new Date().toDateString() + '\n'+'Shipping History ' + '\n' + 'Criteria : \n';

for (const key in pdfFilter) {
 
  if (pdfFilter.hasOwnProperty(key)) {
    pdfFilterString += key + ': ' + pdfFilter[key] + '\n';
  }
}
// Convert the additional information into an array of lines
const additionalInfoLines = pdfFilterString.split('\n').map(line => [line]);

// Map the API data to the desired format
let newData = additionalInfoLines; // Start with the additional info

// Create a header row based on keyMap
const headerRow = Object.values(keyMap);
newData.push(headerRow);

apiData.rowsData.forEach((rec) => {
  let mappedData = Object.keys(keyMap).reduce((obj, k) => {
    obj[keyMap[k]] = rec[k];
    return obj;
  }, {});
  newData.push(Object.values(mappedData));
});

const ws = XLSX.utils.aoa_to_sheet(newData);

const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
const excelBuffer = await XLSX.write(wb, { bookType: "xlsx", type: "array" });
const data = new Blob([excelBuffer], { type: fileType });

addStyleToSheet(data, newData).then((url) => {
  FileSaver.saveAs(url, fileName + ".xlsx");
})

  }

};

const clear = () => {
  
  setMillOrderNoValue(null)
  setMillCoilIDValue(null)
   setFromDate(null);
   setToDate(null);
    setEndUserValue(null);
   setPartNoValue(null)
   setPartNoInputValue("")
    setEndUserPOValue(null)
    setChecked(false);
  setWidthFromValue()
  setLengthFromValue(null)
  setGaugeFromValue(null)
  setWidthToValue(null)
  setLengthToValue(null)
  setGaugeToValue(null)
   
  }

  return (
    <>
      {openMaterialPropertiesModal ? (
        <MaterialPropertiesModal
          mode="S"
          useMetUnt={checked?1:0}
          open={true}
          onClose={hideMaterialPropertiesModal}
        />
      ) : null}
      <Container
        sx={{
          overFlow: "auto",
          display: "flex",
          flex: 1,
          flexDirection: "column",
        }}
      >
        {/* Filter */}
        <Container className="ixFilterContainer" sx={{ height: "auto" }}>
          {/* Displays Filter */}
          <form onSubmit={(e) => handleGo(e, 1)}>
            <Stack
              direction="row"
            >
              <Grid container sx={{ width: "80%" }} spacing={2} direction="row">
                <Grid item xs={1} textAlign="end">Shipped From<MendetoryIcon /></Grid>
                <Grid item xs={3}><Autocomplete
                 noOptionsText="No items found"
                  onOpen={() => {
                    getValue(
                      { prsMd: "B" },
                      setShippedFromOption,
                      setOpenShippedFrom
                    );
                  }}
                  
                  onClose={() => {
                    setOpenShippedFrom(false);
                  }}
                  value={inventoryAtValue ? { dispStr: inventoryAtValue.dispStr } : null}
                  disabled={detaildata?.dsblBrh===1?true:false}
                  options={shippedFromOption}
                  isOptionEqualToValue={(option, value) =>
                    option.keyStr === value.keyStr
                  }
                  getOptionLabel={(option) => option.dispStr}
                  onChange={(event, newValue) => {
                    setInventoryAtValue(newValue ? newValue : "");
                  }}
                  renderInput={(params) => <TextField 
                    
                    onChange={(e) => {SearchServiceCall(e.target.value, { prsMd: "B", srchStr: e.target.value }, setShippedFromOption,
                    setOpenShippedFrom)
                    setInventoryAtValue({ "keyStr": "",
                      "dispStr": e.target.value});
                  }
                  }{...params} />}
                /></Grid>
               {usertype==="I" ? <>   <Grid item xs={1} textAlign="end">Mill<MendetoryIcon /></Grid>
                <Grid item xs={3}>
                  <Autocomplete
                   noOptionsText="No items found"
                    open={openMill}
                    onOpen={() => {
                      getValue({ prsMd: "M" }, setMillOption, setOpenMill);
                    }}
                    onClose={() => {
                      setOpenMill(false);
                    }}
                    value={millValue ? { dispStr: millValue.dispStr } : null}
                    options={millOption}
                    isOptionEqualToValue={(option, value) =>
                      option.dispStr === value.dispStr
                    }
                    getOptionLabel={(option) => option.dispStr}
                    onChange={(event, newValue) => {
                      console.log(newValue)
                      setMillValue(newValue ? newValue : 0);
                      setEndUserValue(null);
                      setPartNoValue(null)
                      setPartNoInputValue("")
                      setRows([]);// console.log(newValue.keyStr);
                    }}

                    renderInput={(params) => (
                      <TextField
                        {...params}
                        value={millValue ? { dispStr: millValue.dispStr } : null}
                        onChange={(e) =>{ SearchServiceCall(e.target.value, { prsMd: "M", srchStr: e.target.value }, setMillOption,
                          setOpenMill)
                          setMillValue({ "keyStr": "",
                          "dispStr": e.target.value});
                        }
                        
                        
                        } />
                    )}
                  /> </Grid></>:null}
                <Grid item xs={1} textAlign="end">Mill Order No</Grid>
                <Grid item xs={3}>
                  <Stack direction="row" spacing={1}>
                    <TextField
                      value={millOrderNoValue || ""}
                      onChange={(e) => {
                        setMillOrderNoValue(e.target.value)
                        setRows([]);
                      }}
                    />
                       {usertype==="I" ? 
                    <Stack direction="row" spacing={1}>
                      <Button
                        onClick={dimensionFilterToggler}

                        styletype="icon">
                        <SquareFootIcon />
                      </Button>
                      <Button
                        type="submit"
                      
                        styletype="icon" >
                        <PlayArrowIcon />
                      </Button>
                      <Button
                        sx={{width:100}}
                    onClick={clear}
                    // sx={{ margin: "3px" }}
                    >
                  clear
                  </Button></Stack>
                     :null}





                  </Stack></Grid>
                <Grid item xs={1} textAlign="end">Mill Coil ID</Grid>
                <Grid item xs={3}>
                <Stack direction="row" spacing={12}>
                  <TextField
                     value={millCoilIDValue || ""}
                  onChange={(e) => setMillCoilIDValue(e.target.value)}
                />
                {usertype !=="I" ? 
                    <Stack direction="row" spacing={1}>
                      <Button
                        onClick={dimensionFilterToggler}

                        styletype="icon">
                        <SquareFootIcon />
                      </Button>
                      <Button
                        type="submit"

                        styletype="icon" >
                        <PlayArrowIcon />
                      </Button>
                        <Button
                    onClick={clear}
                    // sx={{ margin: "3px" }}
                    >
                  clear
                  </Button>
                      </Stack>
                     :null}
                
                
                
                </Stack>
                </Grid>

                <Grid item xs={1} textAlign="end">From Date</Grid>
                <Grid item xs={3}><LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    value={fromDate}
                    onChange={(newDate) => {
                      setFromDate(newDate);
                      setRows([]);
                    }}
                    renderInput={(params) => <TextField sx={{ width: "180px" }}{...params} />}
                  />
                </LocalizationProvider>
                </Grid>
                <Grid item xs={1} textAlign="end">To Date</Grid>
                <Grid item xs={3}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      value={toDate}
                      onChange={(newDate) => {
                        setToDate(newDate);
                        setRows([]);

                      }}
                      renderInput={(params) => <TextField sx={{ width: "180px" }}  {...params} />}
                    />
                  </LocalizationProvider>
                </Grid>

                <Grid item xs={1} textAlign="end">End-User</Grid>
                <Grid item xs={3}>
                  <Autocomplete
                   noOptionsText="No items found"
                    open={openEndUser}
                    onOpen={() => {
                      getValue(
                        { prsMd: "E", fltrStr: millValue?`${millValue.keyStr}`:"" },
                        setEndUserOption,
                        setOpenEndUser
                      );
                    }}
                    onClose={() => {
                      setOpenEndUser(false);
                    }}
                    value={endUserValue ? { dispStr: endUserValue.dispStr } : null}
                    options={endUserOption}
                    isOptionEqualToValue={(option, value) =>
                      option.dispStr === value.dispStr
                    }
                    getOptionLabel={(option) => option.dispStr}
                    onChange={(event, newValue) => {
                      console.log("1111", newValue)
                      setRows([]);
                      setEndUserValue(newValue ? newValue : null);

                      setPartNoValue(null)
                      setPartNoInputValue("")
                      // console.log(newValue.keyStr);

                    }}
                    renderInput={(params) => <TextField onChange={(e) => SearchServiceCall(e.target.value, { prsMd: "E", fltrStr:millValue?`${millValue.keyStr}`:"", srchStr: e.target.value }, setEndUserOption,
                      setOpenEndUser)}{...params} />}
                  />
                </Grid>
                <Grid item xs={1} textAlign="end">Part No</Grid>
                <Grid item xs={3}>
                  <Autocomplete
                   noOptionsText="No items found"
                    freeSolo
                    forcePopupIcon
                    open={openPartNo}
                    value={partNoValue ? (typeof partNoValue === 'string' ? partNoValue : { dispStr: partNoValue.dispStr }) : null}
                    inputValue={partNoInputValue}
                    onInputChange={(event, newInputValue, reason) => {
                      setPartNoInputValue(newInputValue);
                      if (newInputValue && reason === 'input') {
                        setOpenPartNo(true);
                        SearchServiceCall(newInputValue, { prsMd: "P", fltrStr:  `${millValue?millValue.keyStr:""}|${endUserValue?endUserValue?.keyStr:""}`, srchStr: newInputValue }, setPartNoOption,
                          () => setOpenPartNo(true));
                      } else if (!newInputValue) {
                        setOpenPartNo(false);
                      }
                    }}
                    onOpen={() => {
                      setOpenPartNo(true);
                      if (!partNoInputValue) {
                        getValue({ prsMd: "P", fltrStr:  `${millValue?millValue.keyStr:""}|${endUserValue?endUserValue?.keyStr:""}`}, setPartNoOption, setOpenPartNo);
                      }
                    }}
                    onClose={(event, reason) => {
                      if (reason === 'selectOption' || reason === 'blur' || reason === 'escape') {
                        setOpenPartNo(false);
                      }
                    }}
                    options={partNoOption}
                    isOptionEqualToValue={(option, value) =>
                      typeof value === 'string' ? option.dispStr === value : option.dispStr === value.dispStr
                    }
                    getOptionLabel={(option) => typeof option === 'string' ? option : option.dispStr}
                    onChange={(event, newValue) => {
                      if (typeof newValue === 'string') {
                        setPartNoValue({ keyStr: newValue, dispStr: newValue });
                        setPartNoInputValue(newValue);
                      } else {
                        setPartNoValue(newValue ? newValue : null);
                        setPartNoInputValue(newValue ? newValue.dispStr : "");
                      }
                      setRows([]);
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </Grid>
                <Grid item xs={1} textAlign="end">End-User PO</Grid>
                <Grid item xs={3}>
                  <Stack direction="row" spacing={2}>
                    <TextField
                     value={endUserPOValue || ""}
                      onChange={(e) => {
                        setEndUserPOValue(e.target.value)
                        setRows([]);
                      }}
                    />

                    <Box>Use Metric Units</Box>

                    <SwitchPro
                      checked={checked}
                      onChange={(e) => {
                        toggleMetricUnits()
                        setRows([])
                      }}
                      inputProps={{ 'aria-label': 'controlled' }} />

                  </Stack>

                </Grid>

              </Grid>
              <Box>
               
              </Box>
            </Stack>
          </form>


          {dimensionFilterVisibility ? (
            <>
              <div className="spacing" />
              <Container
                className="ixSeparatorLineForFilter"
                sx={{ height: "1px" }}
              />
              <div className="spacing" />
              <Grid container sx={{ width: "80%" }} spacing={2} direction="row">
                <Grid item xs={1} textAlign="end">Width From</Grid>
                <Grid item xs={3}>
                  <TextField
                    type="number"
                    value={widthFromValue || ""}
                    onChange={(e) => setWidthFromValue(e.target.value)} />
                </Grid>
                <Grid item xs={1} textAlign="end">Length From</Grid>
                <Grid item xs={3}>
                  <TextField
                    type="number"
                    value={lengthFromValue || ""}
                    onChange={(e) => setLengthFromValue(e.target.value)}
                  />
                </Grid>
                <Grid item xs={1} textAlign="end">Gauge From</Grid>
                <Grid item xs={3}>
                  <TextField
                    type="number"
                    sx={{ width: "190px" }}
                    value={gaugeFromValue || ""}
                    onChange={(e) => setGaugeFromValue(e.target.value)} />
                </Grid>
                <Grid item xs={1} textAlign="end">Width To</Grid>
                <Grid item xs={3}>
                  <TextField
                    type="number"
                    value={widthToValue || ""}
                    onChange={(e) => setWidthToValue(e.target.value)}
                  />
                </Grid>
                <Grid item xs={1} textAlign="end">Length To</Grid>
                <Grid item xs={3}>

                  <TextField
                    type="number"
                    value={lengthToValue || ""}
                    onChange={(e) => setLengthToValue(e.target.value)}
                  />
                </Grid>
                <Grid item xs={1} textAlign="end">Gauge To</Grid>
                <Grid item xs={3}>

                  <TextField
                    type="number"
                    value={gaugeToValue || ""}
                    sx={{ width: "190px" }}
                    onChange={(e) => setGaugeToValue(e.target.value)}
                  />
                </Grid>
              </Grid>

            </>
          ) : null}
        </Container>
        {/* ) : (
          // <Container className="ixFilterContainer" sx={{ height: "auto" }}>
          //   <Container
          //     sx={{
          //       display: "flex",
          //       flexDirection: "row",
          //       justifyContent: "flex-end",
          //     }}
          //   >
          //     <Button
          //       onClick={() => setFilterVisibility(true)}
          //       sx={{ margin: "3px" }}
          //       styletype="icon"
          //     >
          //       <PushPinIcon />
          //     </Button>
          //   </Container>
          // </Container>
        ) */}
        <div className="spacing"> </div>

        {/* Data Table */}
        <Container
          className="ixBrowseGridLayout"
          sx={{ display: "flex", flexDirection: "column" }}
        >
            {rows.length > 0 ? 
            <Container className="ixBrowseGridActionBar" sx={{ height: "50px " }}>
            <Stack
              className="ixBrowseGridActionBarContents"
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              spacing={0.5}
            >
              <Stack direction="row" alignItems="center" spacing={0.5}>
              {/* <Button disabled={nextRecord ? false : true} styletype="icon" onClick={(e) => handleGo(e, 0)}>
                  <DoubleArrowIcon />
                </Button>
                <Button styletype="icon" onClick={(e) => handleGo(e, 1)}>
                  <SyncIcon />
                </Button> */}
                <Button styletype="icon" onClick={handleMore}>
                  <MoreVertIcon />
                </Button>
              </Stack>
            </Stack>
            {/* <div className="spacing">   </div> */}
            <Menu
              PaperProps={{
                // sx: {
                //     border: "2px red solid"
                // },
                className: "invPopupMenuVeryDark",
              }}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              //PopoverClasses={"invPopupMenuVeryDark"}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
            >
                <MenuItem onClick={handlePrint} >

Export to PDF</MenuItem>
<MenuItem onClick={exportToXls} >

Export to XLS
</MenuItem>
              <MenuItem>Help</MenuItem>
            </Menu>
          </Container>:null}
          <Container className="ixBrowseGridContainer">
            <DataGridPro
              getRowClassName={(params) => params.row.isTot === 1 ? `bold` : ``}
              headerHeight={40}
              columnBuffer={10}
              hideFooter={true}
              apiRef={apiRef}
              columns={assetColumns}
              rowHeight={30}
              disableColumnMenu={true}
              getRowId={(row) => row.rowId}
              rows={rows}
              loading={!rows.length}
              onCellClick={handleCellClick}
            />
          </Container>
        </Container>
      </Container>
      {
        openPdf ?
          <Box style={{
            flex: 1,
            displayPrint: 'block',
          }}>
            <ShippingPdf ref={componentRef} wgtUm={wgtUm} data={openPdf} filter={pdfFilter} />
          </Box>
          : null
      }
    </>
  );
}
export default BrowseContainer;
